module.exports = __webpack_public_path__ + "static/Automation_Leads_Ageing_Distribution_highres-03979432d4079af80b118bc4719a25e0.jpg";